module.exports = __webpack_public_path__ + "static/media/image-1.fb92c325.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Catalog/image-1.png
// module id = 258
// module chunks = 0